import React, { forwardRef } from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faCalendarAlt, faDollarSign, faHashtag, faPercentage, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import DatePicker, { getDay } from 'react-datepicker';
import es from 'date-fns/locale/es'
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from 'react-datepicker';
import moment from 'moment/moment';
registerLocale('es', es);

class Crear extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }
    state = {
        rolPQR: false,
        fecha_ingreso: '',
        fecha_vencimiento: '',
        estado_pqr: '',
        radicado: '',
        id_departamento: '',
        id_municipio: '',
        abreviatura_municipio: '',
        barrio: '',
        tipo_persona: '',
        identificacion: '',
        nombres: '',
        apellidos: '',
        cargo: '',
        direccion: '',
        telefono: '',
        correo_electronico: '',
        id_tipo_asunto: '',
        abreviatura_tipo_asunto: '',
        peticion: '',
        requiere_visita: '',
        observaciones: '',
        tipoAsuntos: [],
        departamentosVisita: [],
        municipiosVisita: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { fecha_ingreso, fecha_vencimiento, estado_pqr, id_departamento, id_municipio, barrio,
                tipo_persona, identificacion, nombres, apellidos, id_tipo_asunto, peticion, requiere_visita
            } = this.state;
        var errores = [];
        if (!fecha_ingreso) { errores.push("error_fecha_ingreso"); }
        if (!fecha_vencimiento) { errores.push("error_fecha_vencimiento"); }
        if (!estado_pqr) { errores.push("error_estado_factura"); }
        if (!id_departamento) { errores.push("error_id_departamento"); }
        if (!id_municipio) { errores.push("error_id_municipio"); }
        if (!barrio) { errores.push("error_periodo_factura"); }
        if (!tipo_persona) { errores.push("error_id_contribuyente"); }
        if (!identificacion) { errores.push("error_acuerdo_municipal"); }
        if (!nombres) { errores.push("error_tipo_cliente"); }
        if (!apellidos) { errores.push("error_liq_vencidas"); }
        if (!id_tipo_asunto) { errores.push("error_valor_liq_vencidas"); }
        if (!peticion) { errores.push("error_tipo_facturacion"); }
        if (!requiere_visita) { errores.push("error_tarifa"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        formData.append('id_departamento', window.localStorage.getItem('id_cod_dpto'));
        formData.append('id_municipio', window.localStorage.getItem('id_cod_mpio'));
        console.log(formData);
        Swal.showLoading();
        authAxios.post("pqr/registrar", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'P.Q.R.!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterPQR");
                } else {
                    Swal.close();
                    Swal.fire(
                        'P.Q.R.!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    handleChange = (date) => {
        const fecha_ingreso = moment(date).format("YYYY-MM-DD");
        this.setState({ fecha_ingreso: fecha_ingreso });
        document.getElementById("fecha_ingreso").value = fecha_ingreso;
    }
    isWeekday = (date) => {
        const day = date.getDay();
        return day !== 0 && day !== 6;
    }
    cargarMunicipios() {
        var id_departamento = document.getElementById('id_departamento').value;
        Swal.showLoading();
        authAxios.get("municipios_visitas/buscardepartamento/" + id_departamento)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, municipiosVisita: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    crearRadicado = () => {
        Swal.showLoading();
        var id_departamento = document.getElementById("id_departamento").value;
        var id_municipio = document.getElementById("id_municipio").value;
        var id_tipo_asunto = document.getElementById("id_tipo_asunto").value;
        var fecha_ingreso = document.getElementById("fecha_ingreso").value.replaceAll("-", "");
        authAxios.get("pqr/generar_radicado/" + id_departamento + "/" + id_municipio + "/" + id_tipo_asunto)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, radicado: datosRespuesta.data.resultadoTipoAsunto.ABREVIATURA + datosRespuesta.data.resultadoMunicipio.ABREVIATURA + fecha_ingreso, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    calcularFecha = () => {
        Swal.showLoading();
        var fecha_ingreso = document.getElementById("fecha_ingreso").value;
        authAxios.get("pqr/calcular_fecha/" + fecha_ingreso)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, fecha_vencimiento: datosRespuesta.data, load: '' });
                document.getElementById("fecha_vencimiento").value = datosRespuesta.data;
                Swal.close();
            })
            .catch(console.log);
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, departamentosVisita: datosRespuesta.data.data, load: '' });
                if (window.localStorage.getItem('id_cod_dpto') !== '0') {
                    this.setState({ rolPQR: true, id_departamento: window.localStorage.getItem('id_cod_dpto'), id_municipio: window.localStorage.getItem('id_cod_mpio') })
                    this.cargarMunicipios();
                }
            })
            .catch(console.log);
        authAxios.get("pqr/tipo_asuntos")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, tipoAsuntos: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { rolPQR, fecha_ingreso, fecha_vencimiento, radicado, estado_pqr, id_departamento, id_municipio, barrio,
                tipo_persona, identificacion, nombres, apellidos, cargo, direccion, telefono, correo_electronico,
                id_tipo_asunto, peticion, requiere_visita, observaciones, tipoAsuntos, departamentosVisita, municipiosVisita
            } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRO DE P.Q.R.</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="form">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="fecha_ingreso">Fecha Ingreso</label>
                                                    <input type="hidden" name="id_usuario" id="id_usuario" value={window.localStorage.getItem('idusuario')} />
                                                    {/* <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_ingreso" id="fecha_ingreso" value={fecha_ingreso}
                                                            className={((this.verificarError("error_fecha_ingreso")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA INGRESO" aria-describedby="helpId"
                                                            onChange={(e) => {
                                                                this.cambioValor(e);
                                                                this.calcularFecha(e);
                                                            }} />
                                                    </div> */}
                                                    <DatePicker
                                                        className={((this.verificarError("error_fecha_ingreso")) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                        dateFormat="yyyy-MM-dd"
                                                        selected={Date.parse(fecha_ingreso)}
                                                        value={fecha_ingreso}
                                                        id="fecha_ingreso"
                                                        name="fecha_ingreso"
                                                        locale="es"
                                                        aria-describedby="helpId"
                                                        placeholderText="DD/MM/YYYY"
                                                        filterDate={this.isWeekday}
                                                        excludeDates={[ 1673240400000, 1679288400000, 1680757200000, 1680843600000, 1682917200000, 1684731600000,
                                                                        1686546000000, 1687150800000, 1688360400000, 1689829200000, 1691384400000, 1692594000000,
                                                                        1697432400000, 1699246800000, 1699851600000, 1702011600000, 1703480400000,
                                                                        1704085200000, 1704690000000, 1711342800000, 1711602000000, 1711688400000, 1714539600000,
                                                                        1715576400000, 1717390800000, 1717995600000, 1719810000000, 1721451600000, 1723006800000,
                                                                        1724043600000, 1728882000000, 1730696400000, 1731301200000, 1735102800000, 1735707600000 ]}
                                                        onKeyDown={(e) => {
                                                            e.preventDefault();
                                                        }}
                                                        onChange={(e) => {
                                                            this.handleChange(e);
                                                            this.calcularFecha(e);
                                                        }}
                                                    />
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Ingreso</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="fecha_vencimiento">Fecha Vencimiento</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_vencimiento" id="fecha_vencimiento" value={fecha_vencimiento}
                                                            className={((this.verificarError("error_fecha_vencimiento")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA VENCIMIENTO" aria-describedby="helpId"
                                                            onChange={this.cambioValor} readOnly />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Vencimiento</small>
                                                </div>
                                                <div className='col-md-2'></div>
                                                <div className='col-md-3'></div>
                                                <div className='col-md-3'>
                                                    <label htmlFor="estado_pqr">Estado P.Q.R.</label>
                                                    <select name="estado_pqr"
                                                        id="estado_pqr"
                                                        className={((this.verificarError("error_estado_pqr")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Estado P.Q.R.</option>
                                                        <option value="1">RECIBIDO</option>
                                                        <option value="2">RESUELTO</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Estado P.Q.R.</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN MUNICIPIO / CONTRIBUYENTE</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-3'>
                                                    <label htmlFor="id_departamento">Departamento</label>
                                                    <select name="id_departamento"
                                                        id="id_departamento"
                                                        value={
                                                            window.localStorage.getItem('id_cod_dpto') !== '0' ?
                                                                window.localStorage.getItem('id_cod_dpto')
                                                            :
                                                                null
                                                        }
                                                        className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={e => {
                                                            this.cargarMunicipios(e);
                                                            this.cambioValor(e)
                                                        }} disabled={rolPQR}>
                                                        <option value="">Seleccione el Departamento</option>
                                                        {
                                                            departamentosVisita.map((itemDepartamentosVisita) => (
                                                                <option key={itemDepartamentosVisita.ID_TABLA} value={itemDepartamentosVisita.ID_DEPARTAMENTO}>{itemDepartamentosVisita.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                </div>
                                                <div className='col-md-3'>
                                                    <label htmlFor="id_municipio">Municipio</label>
                                                    <select name="id_municipio"
                                                        id="id_municipio"
                                                        value={
                                                            window.localStorage.getItem('id_cod_mpio') !== '0' ?
                                                                window.localStorage.getItem('id_cod_mpio')
                                                            :
                                                                null
                                                        }
                                                        className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor} disabled={rolPQR}>
                                                        <option value="">Seleccione el Municipio</option>
                                                        {
                                                            municipiosVisita.map((itemMunicipiosVisita) => (
                                                                <option key={itemMunicipiosVisita.ID_TABLA} value={itemMunicipiosVisita.ID_MUNICIPIO}>{itemMunicipiosVisita.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="barrio">Barrio</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="barrio" id="barrio" value={barrio}
                                                        className={((this.verificarError("error_barrio")) ? "is-invalid" : "") + " form-control form-control-sm"}  placeholder="BARRIO" aria-describedby="helpId"
                                                        onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Barrio</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-2'>
                                                    <label htmlFor="tipo_persona">Tipo Persona</label>
                                                    <select name="tipo_persona"
                                                        id="tipo_persona"
                                                        className={((this.verificarError("error_tipo_persona")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Tipo Cliente</option>
                                                        <option value="1">NATURAL</option>
                                                        <option value="2">JURIDICA</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo Persona</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="identificacion">Identificación</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="identificacion" id="identificacion" value={identificacion}
                                                            className={((this.verificarError("error_identificacion")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="IDENTIFICACIÓN" aria-describedby="helpId"
                                                            onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite la Identificación</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="nombres">Nombres</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombres" id="nombres" value={nombres} 
                                                        className={((this.verificarError("error_nombres")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="NOMBRES" aria-describedby="helpId"
                                                        onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite los Nombres</small>
                                                </div>
                                                <div className="col-md-4">
                                                    <label htmlFor="apellidos">Apellidos</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="apellidos" id="apellidos" value={apellidos} 
                                                        className={((this.verificarError("error_apellidos")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="APELLIDOS" aria-describedby="helpId"
                                                        onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite los Apellidos</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="cargo">Cargo</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="cargo" id="cargo" value={cargo} 
                                                        className={((this.verificarError("error_cargo")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="CARGO" aria-describedby="helpId"
                                                        onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Cargo</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="direccion">Dirección</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="direccion" id="direccion" value={direccion} 
                                                        className={((this.verificarError("error_direccion")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="DIRECCIÓN" aria-describedby="helpId"
                                                        onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite la Dirección</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="telefono">Teléfono</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="telefono" id="telefono" value={telefono} 
                                                        className={((this.verificarError("error_telefono")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="TELEFONO" aria-describedby="helpId"
                                                        onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Teléfono</small>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="correo_electronico">Correo Electrónico</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="correo_electronico" id="correo_electronico" value={correo_electronico} 
                                                            className={((this.verificarError("error_correo_electronico")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="CORREO ELECTRÓNICO" aria-describedby="helpId"
                                                            onChange={this.cambioValor} />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Correo Electrónico</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN P.Q.R.</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className="row g-3">
                                                <div className="col-md-3">
                                                    <label htmlFor="radicado">Radicado</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="radicado" id="radicado" defaultValue={radicado} 
                                                            className={((this.verificarError("error_radicado")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="RADICADO" aria-describedby="helpId"
                                                            onChange={this.cambioValor} readOnly />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Radicado</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className="row g-3">
                                                <div className='col-md-6'>
                                                    <label htmlFor="id_tipo_asunto">Tipo Asunto</label>
                                                    <select name="id_tipo_asunto"
                                                        id="id_tipo_asunto"
                                                        className={((this.verificarError("error_id_tipo_asunto")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={(e) => {
                                                            this.crearRadicado(e);
                                                            this.cambioValor(e);
                                                        }}>
                                                        <option value="">Seleccione el Tipo Asunto</option>
                                                        {
                                                            tipoAsuntos.map((itemTipoAsunto) => (
                                                                <option key={itemTipoAsunto.ID_TIPO_ASUNTO} value={itemTipoAsunto.ID_TIPO_ASUNTO}>{itemTipoAsunto.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo Asunto</small>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="peticion">Petición</label>
                                                    <select name="peticion"
                                                        id="peticion"
                                                        className={((this.verificarError("error_peticion")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione la Petición</option>
                                                        <option value="1">ESCRITA</option>
                                                        <option value="2">VERBAL</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Petición</small>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="requiere_visita">Requiere Visita</label>
                                                    <select name="requiere_visita"
                                                        id="requiere_visita"
                                                        className={((this.verificarError("error_requiere_visita")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione si Requiere Visita</option>
                                                        <option value="1">SI</option>
                                                        <option value="2">NO</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione si Requiere Visita</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-12">
                                                    <label htmlFor="observaciones">Observaciones</label>
                                                    <textarea style={{ resize: 'none', textTransform: 'uppercase' }} className='form-control form-control-sm' id="observaciones" name="observaciones" rows='3' onChange={this.cambioValor} aria-describedby="helpId"></textarea>
                                                    <small id="helpId" className="invalid-feedback">Digite las Observaciones</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear P.Q.R.</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterPQR"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;